import React, { useState, useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import Button from './Button';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const FixedWrapper = styled('div')`
  position: fixed;
  z-index: 9999;
  top: 0;
  width: ${(props) =>
    props.modalRef.current ? props.modalRef.current.clientWidth + 'px' : 'initial'};
  background-color: #fff;
`;

const Wrapper = styled(`div`)`
  .border-block {
    margin: 0 -24px;
    border-top: 1px solid #f1f5f8;
  }
`;

const Modal = (props) => {
  const {
    loading,
    disabled,
    hideFooter,
    title,
    className = 'modal-lg',
    modalStyle = {},
    modalBodyStyle = {},
    headerStyle = {},
    footerStyle = {},
    children,
    customHeader = null,
    customHeaderProps = {},
    customFooter = null,
    customFooterProps = {},
    fixedHeader = null,
    onClose,
    onSubmit = () => false,
    isCloseOnClickInside = true,
    closeAfterEvent = null,
    buttonSubmitText = null,
  } = props;

  const [showFixedHeader, setShowFixedHeader] = useState(false);
  const modalRef = useRef(null);

  const { t } = useAutoTranslation();

  useEffect(() => {
    const clickEventHandler = (event) => {
      const specifiedElement = document.getElementById('modalBlock');
      const fixedHeaderElement = document.getElementById('modalFixedHeader');
      const isClickInside = specifiedElement.contains(event.target);
      const isClickInsideFixedHeader =
        fixedHeaderElement && fixedHeaderElement.contains(event.target);
      if (!isClickInside && !isClickInsideFixedHeader && isCloseOnClickInside) {
        onClose();
      }
    };

    const keyDownEventHandler = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('mousedown', clickEventHandler, false);
    window.addEventListener('touchstart', clickEventHandler, false);
    window.addEventListener('keydown', keyDownEventHandler, false);

    return () => {
      window.removeEventListener('mousedown', clickEventHandler, false);
      window.removeEventListener('touchstart', clickEventHandler, false);
      window.removeEventListener('keydown', keyDownEventHandler, false);
    };
  }, []);

  const modalClassName = `modal-dialog ${className}`;

  const handleModalScroll = (e) => {
    setShowFixedHeader(e.target.scrollTop >= 30);
  };

  const FixedHeader = fixedHeader;
  const CustomHeader = customHeader;
  const CustomFooter = customFooter;

  if (closeAfterEvent) {
    onClose();
  }

  return (
    <Wrapper
      className="modal fade show"
      role="dialog"
      aria-modal="true"
      onScroll={handleModalScroll}
    >
      <div
        className={modalClassName}
        id="modalBlock"
        data-testid="modalStyle"
        style={modalStyle}
        ref={modalRef}
      >
        <div className="modal-content">
          {showFixedHeader && fixedHeader ? (
            <FixedWrapper modalRef={modalRef} data-testid="fixed-header">
              <FixedHeader />
            </FixedWrapper>
          ) : null}
          {!customHeader ? (
            <div className="modal-header" style={headerStyle} data-testid="headerStyle">
              <h4 className="modal-title">{t(title)}</h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-hidden="true"
                onClick={onClose}
              >
                ×
              </button>
            </div>
          ) : (
            <CustomHeader {...customHeaderProps} />
          )}
          <div className="modal-body" style={modalBodyStyle} data-testid="modalBodyStyle">
            {children}
          </div>
          {!hideFooter &&
            (!customFooter ? (
              <div className="modal-footer" style={footerStyle} data-testid="footerStyle">
                <Button
                  text={t(buttonSubmitText || 'Сохранить')}
                  onClick={onSubmit}
                  loading={loading}
                  disabled={disabled || loading}
                />
              </div>
            ) : (
              <CustomFooter {...customFooterProps} />
            ))}
        </div>
      </div>
    </Wrapper>
  );
};

export default Modal;
